import { Fit } from "@skbkontur/react-stack-layout";
import { Link } from "@skbkontur/react-ui";
import * as React from "react";

import { Action, ActionType } from "../../Domain/Actions";
import { nullElement } from "../../Utils/TypingUtils";
import cn from "../App/FormsHelperApplication.less";
import { DeveloperHint } from "../DeveloperHint/DeveloperHint";

interface ActionViewProps {
    action: Action;
    onCreateEmptyDraft: (gfv: string) => Promise<void>;
    onGetOpenEditorUrl: (url: string) => string;
}

export function ActionView({ action, onCreateEmptyDraft, onGetOpenEditorUrl }: ActionViewProps): JSX.Element | null {
    if (action.type === ActionType.OpenEmpty) {
        return (
            <Fit>
                <span className={cn("gfv")}>{action.gfv}</span>. Создан пустой черновик.
                <div className={cn("date-string")}>{printDate(action.dateString)}</div>
                <div>
                    <Link onClick={() => onCreateEmptyDraft(action.gfv)}>Создать заново и открыть</Link>
                </div>
                <div>
                    {action.editorUrl != undefined && (
                        <Link target={"_blank"} href={onGetOpenEditorUrl(action.editorUrl)}>
                            Открыть созданный черновик
                        </Link>
                    )}
                </div>
            </Fit>
        );
    }
    if (action.type === ActionType.UploadFuf) {
        return (
            <Fit>
                <span className={cn("gfv")}>{action.gfv}</span>. Загружен фуф
                <div className={cn("date-string")}>{printDate(action.dateString)}</div>
                <div>
                    <DeveloperHint>
                        <Link disabled>Создать заново на основе ФУФа</Link>
                    </DeveloperHint>
                </div>
                <div>
                    <Link target={"_blank"} href={onGetOpenEditorUrl(action.editorUrl)}>
                        Открыть созданный черновик
                    </Link>
                </div>
            </Fit>
        );
    }
    return nullElement;
}

function printDate(dateString: string): string {
    return `${new Date(dateString).toLocaleTimeString()} ${new Date(dateString).toLocaleDateString()}`;
}
